import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { ProfileService } from '../profile/profile.service';
import { DOCUMENT } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'jfriedman-upload-pdf',
  templateUrl: './uploadpdf.component.html',
  styleUrls: ['uploadpdf.component.scss']
})
export class JFriedmanUploadPdfComponent implements OnInit, OnDestroy {
  public isAuthenticated: boolean = false;
  public selectedFile: File | null = null;
  public busyUploading: boolean = false;
  public uploadError: string = '';
  public response: any = null;

  constructor(private authorizeService: AuthorizeService,
    private http: HttpClient, private router: Router, private route: ActivatedRoute,
    private profileSvc: ProfileService, private sanitizer: DomSanitizer,
    private authSvc: AuthorizeService, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) {

    const elm = this.document.getElementById("nav-menu");
    if (elm) this.renderer.addClass(elm, 'hideme');
    const elm2 = this.document.getElementById("app-footer");
    if (elm2) this.renderer.addClass(elm2, 'hideme');
  }

  public ngOnDestroy(): void {
    const elm = this.document.getElementById("nav-menu");
    if (elm) this.renderer.removeClass(elm, 'hideme');
    const elm2 = this.document.getElementById("app-footer");
    if (elm2) this.renderer.removeClass(elm2, 'hideme');
  }

  async ngOnInit(): Promise<void> {
    var token = await this.authSvc.getToken();
    if (token.sub != "acfc2497-cb44-4394-b866-3f546b306ff6"
      && token.sub != "75188666-0c61-4d26-b4d1-d184befa3afb" // Alec Lubin
      && token.sub != '074e9283-ff17-49c1-b6f8-787d11dad581'
      && token.sub != '75188666-0c61-4d26-b4d1-d184befa3afb'
      && token.sub != 'ff08b278-700d-4d51-a589-42034ab6c925' // Steve Cohn
    ) this.router.navigate(['/home']);

    this.http.get('/jfriedman/authstatus').subscribe(
      (resp: any) => {
        console.log('resp ', resp);
        // if not logged in, redirect to login
        if (!resp.isLoggedIn)
          this.router.navigate(['/jfriedman/login']);
      },
      (err: any) => {
        console.error('login status threw exception');
      }
    )
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.selectedFile = file;
      this.uploadError = '';
    } else {
      this.uploadError = 'Please select a valid PDF file.';
      this.selectedFile = null;
    }
  }

  onFileDropped(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf') {
        this.selectedFile = file;
        this.uploadError = '';
      } else {
        this.uploadError = 'Please select a valid PDF file.';
        this.selectedFile = null;
      }
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
  }

  uploadAndParseDocument(): void {
    if (!this.selectedFile) {
      this.uploadError = 'Please select a PDF file first.';
      return;
    }

    this.busyUploading = true;
    this.uploadError = '';
    this.response = null;

    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.http.post('/jfriedman/parsepdf', formData).subscribe(
      (resp: any) => {
        console.log('PDF parse response: ', resp);
        this.response = resp;
        const caseNumber = resp?.caseDetails?.caseNumber || resp?.caseNumber;
        this.busyUploading = false;
        if (caseNumber) {
          this.router.navigate([`/jfriedman/${encodeURIComponent(caseNumber)}/home`]);
        }
      },
      (err: any) => {
        console.error('PDF parse threw exception', err);
        this.uploadError = 'Error parsing PDF. Please try again. Error: ' + (err.error?.message || err.message || 'Unknown error');
        this.response = null;
        this.busyUploading = false;
      }
    );
  }

  proceedToGenerateBrief(): void {
    if (this.response) {
      const caseNumber = this.response?.caseDetails?.caseNumber;
      if (caseNumber) {
        this.router.navigate([`/jfriedman/${encodeURIComponent(caseNumber)}/home`]);
      }
    }
  }

  safe(text: any) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
